import { forwardRef, useImperativeHandle, useState } from 'react';
import { Form } from 'react-bootstrap';

export type CancelCommentFormHandle = {
  getComment: () => string;
};

type CancelCommentFormProps = {
  label: string;
  placeholder?: string;
};

const CancelCommentForm = forwardRef<
  CancelCommentFormHandle,
  CancelCommentFormProps
>(({ label, placeholder = 'Reason for cancel or defer' }, ref) => {
  const [value, setValue] = useState('');

  useImperativeHandle(ref, () => ({
    getComment: () => value.trim()
  }));

  return (
    <Form>
      <Form.Group>
        <Form.Label>{label}</Form.Label>
        <Form.Control
          as="textarea"
          rows={3}
          value={value}
          onChange={e => setValue(e.target.value)}
          placeholder={placeholder}
        />
      </Form.Group>
    </Form>
  );
});

CancelCommentForm.displayName = 'CancelCommentForm';

export default CancelCommentForm;
